import { ApolloError } from '@apollo/client'
import { Popover } from '@mui/material'
import React from 'react'
import { BudgetHistoryContent } from './BudgetHistoryContent'
import { AdGroupBudgetHistoryEntry } from './budgetHistoryTypes'

type BudgetHistoryPopoverProps = {
  anchorEl: HTMLElement | null
  open: boolean
  onClose: () => void
  onContentMouseEnter?: () => void
  onContentMouseLeave?: () => void
  changes: AdGroupBudgetHistoryEntry[]
  loading: boolean
  error: ApolloError | undefined
}

export const BudgetHistoryPopover: React.FC<BudgetHistoryPopoverProps> = ({
  anchorEl,
  open,
  onClose,
  onContentMouseEnter,
  onContentMouseLeave,
  changes,
  loading,
  error,
}) => (
  <Popover
    open={open}
    anchorEl={anchorEl}
    onClose={onClose}
    disableRestoreFocus
    disableAutoFocus
    disableEnforceFocus
    sx={{ pointerEvents: 'none' }}
    anchorOrigin={{ vertical: 'center', horizontal: 'left' }}
    transformOrigin={{ vertical: 'center', horizontal: 'right' }}
    slotProps={{
      paper: {
        sx: { width: 880, maxWidth: '95vw', px: 2, py: 2, pointerEvents: 'auto', boxSizing: 'border-box' },
        onMouseEnter: onContentMouseEnter,
        onMouseLeave: onContentMouseLeave,
      },
    }}
  >
    <BudgetHistoryContent changes={changes} loading={loading} error={error} dense />
  </Popover>
)
